module.exports = require('./dist');


//////////////////
// WEBPACK FOOTER
// ./~/vue-croppie/index.js
// module id = 213
// module chunks = 11